import { orchestrator } from 'satcheljs';
import { observableTodayChanged } from 'owa-observable-datetime';
import { getModuleCommand } from 'owa-publishedcalendar-settings';
import goToToday from '../actions/goToToday';

/**
 * Orchestrator needed when observable today value has changed
 */
orchestrator(observableTodayChanged, () => {
    if (!getModuleCommand()) {
        goToToday();
    }
});
